import { useState } from "react";
import { Form, FormActions, FormInput, FormTextArea } from "../Controls/Form";
import API from "@src/API.js";
import { MdHelp, MdEdit } from "react-icons/md";

function normalizeHelp(raw, fallbackId) {
  if (!raw || typeof raw !== "object") {
    return { ID: fallbackId || 0, Title: "", Content: "", LocationID: 0, TypeID: 0 };
  }
  return {
    ID: Number(raw.ID ?? raw.id ?? fallbackId ?? 0) || 0,
    Title: raw.Title ?? raw.title ?? "",
    Content: raw.Content ?? raw.content ?? "",
    LocationID: Number(raw.LocationID ?? raw.locationID ?? 0) || 0,
    TypeID: Number(raw.TypeID ?? raw.typeID ?? 0) || 0,
  };
}

export default function Help(props) {
  const helpId = Number(props.id) || 0;
  const [mode, setMode] = useState("off");
  const [help, updateHelp] = useState(() => normalizeHelp(null, helpId));
  const [loading, setLoading] = useState(false);

  async function onClick() {
    if (loading) return;
    setLoading(true);
    try {
      const resp = await API.getAsync("/Help?id=" + helpId);
      if (resp?.ok) {
        updateHelp(normalizeHelp(resp.jsonData, helpId));
        setMode("message");
      }
    } finally {
      setLoading(false);
    }
  }

  function onClose() {
    setMode("off");
  }

  function onEdit() {
    setMode("edit");
  }

  async function onDoneAsync() {
    const payload = {
      ID: help.ID || 0,
      Title: help.Title || help.title || "",
      Content: help.Content || help.content || "",
      LocationID: help.LocationID || 0,
      TypeID: help.TypeID || 0,
    };
    const resp = await API.postAsync("/PostHelp", payload);
    if (resp?.ok) {
      const newId = resp.jsonData?.id ?? resp.jsonData?.ID ?? resp.jsonData;
      if ((payload.ID === 0 || !payload.ID) && Number(newId) > 0) {
        updateHelp((prev) => ({ ...prev, ID: Number(newId) }));
      }
      setMode("off");
    }
  }

  const title = help.Title || help.title || "";
  const content = help.Content || help.content || "";

  return (
    <span className="HelpIcon">
      <div className={"background" + (mode === "off" ? " hidden" : "")} onClick={onClose} />
      <MdHelp onClick={onClick} aria-label="Help" role="button" />
      <div className={"helpMessage" + (mode === "off" ? " hidden" : "")}>
        {mode === "message" ? (
          <>
            <span className="title">
              {title || "Help"}
              <span className="right">
                <MdEdit onClick={onEdit} aria-label="Edit help" role="button" />
              </span>
            </span>
            <span className="content">
              {content || "No help content has been written for this topic yet."}
            </span>
          </>
        ) : null}
        {mode === "edit" ? (
          <Form object={help} onUpdate={updateHelp}>
            <FormInput field="Title" label="Title" />
            <FormTextArea field="Content" label="Message" />
            <FormActions
              onSaveAsync={async () => {
                await onDoneAsync();
              }}
              onCancelAsync={async () => {
                setMode("message");
              }}
            />
          </Form>
        ) : null}
      </div>
      <div className={"edit" + (mode === "off" ? " hidden" : "")} />
    </span>
  );
}
